/**
 * @generated SignedSource<<8a7a7edf8ac91b4ae370a72aa6d3c7d4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SetFirstTimePasswordInput = {
  password: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  phoneNumber?: string | null;
  title?: string | null;
  toolUsed?: string | null;
  website?: string | null;
  companyName?: string | null;
  timezone?: string | null;
  key: string;
  language?: string | null;
  interest?: string | null;
  companySize?: string | null;
  businessType?: string | null;
  teamType?: string | null;
  roleType?: string | null;
  roleId?: string | null;
  helpFromRealPerson?: string | null;
  economicToken?: string | null;
  termsVersionAccepted?: string | null;
  autoJoinAccepted?: boolean | null;
  noSampleProject?: boolean | null;
  clientMutationId?: string | null;
};
export type setFirstTimePasswordMutation$variables = {
  input: SetFirstTimePasswordInput;
};
export type setFirstTimePasswordMutation$data = {
  readonly setFirstTimePassword: {
    readonly personId: string | null;
    readonly companyId: string | null;
    readonly companyTier: string | null;
    readonly csrfToken: string | null;
    readonly profiles: ReadonlyArray<{
      readonly id: string;
      readonly name: string | null;
    } | null> | null;
    readonly success: boolean | null;
    readonly errors: ReadonlyArray<string | null> | null;
  } | null;
};
export type setFirstTimePasswordMutation = {
  variables: setFirstTimePasswordMutation$variables;
  response: setFirstTimePasswordMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SetFirstTimePasswordPayload",
    "kind": "LinkedField",
    "name": "setFirstTimePassword",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "personId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "companyId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "companyTier",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "csrfToken",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Profile",
        "kind": "LinkedField",
        "name": "profiles",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "setFirstTimePasswordMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "setFirstTimePasswordMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "480d81ed4bb02c6d30486799451270c1",
    "id": null,
    "metadata": {},
    "name": "setFirstTimePasswordMutation",
    "operationKind": "mutation",
    "text": "mutation setFirstTimePasswordMutation(\n  $input: SetFirstTimePasswordInput!\n) {\n  setFirstTimePassword(input: $input) {\n    personId\n    companyId\n    companyTier\n    csrfToken\n    profiles {\n      id\n      name\n    }\n    success\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "9ea82a3ac4d2335fb702b2c1c5e390c1";

export default node;
